import React from 'react';

const StockAdjustmentView = ({ initialData, onClose }) => {
    const data = initialData || {};

    const qty = parseFloat(data.quantity) || 0;
    const isIncrease = qty > 0;
    const qtyDisplay = `${isIncrease ? '+' : ''}${qty.toFixed(3)}`;
    const qtyLabel = isIncrease ? 'Increase' : 'Decrease';
    const qtyColor = isIncrease ? 'text-success' : 'text-danger';

    const sectionLabel = (text) => (
        <small
            className="text-muted text-uppercase fw-semibold"
            style={{ letterSpacing: '0.5px', display: 'block', marginBottom: 8 }}
        >
            {text}
        </small>
    );

    const fieldRow = (label, content) => (
        <div className="d-flex align-items-center" style={{ padding: '6px 12px', background: '#f8f9fa', borderRadius: 4, marginBottom: 4 }}>
            <small className="text-muted" style={{ minWidth: 130, flexShrink: 0 }}>{label}</small>
            {content}
        </div>
    );

    const fieldValue = (label, value) => (
        fieldRow(label, <span className="fw-semibold small">{value}</span>)
    );

    return (
        <div className="h-100 d-flex flex-column">
            {/* Title */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">{data.adjustment_number || 'Stock Adjustment'}</h5>
                {onClose && (
                    <button
                        type="button"
                        className="btn-close"
                        onClick={onClose}
                        aria-label="Close"
                    />
                )}
            </div>

            <div className="flex-grow-1">
                {/* Section 1: Adjustment Details */}
                {sectionLabel('Adjustment Details')}
                <div className="mb-3">
                    {fieldValue('Adjustment Date', data.adjustment_date || '-')}
                    {fieldValue('Location', data.location_name || '-')}
                    {fieldRow('Reason', (
                        <span className={`badge ${data.reason === 'damage' || data.reason === 'theft' ? 'bg-danger' : 'bg-primary'}`}>
                            {data.reason_label || data.reason || '-'}
                        </span>
                    ))}
                    {fieldValue('Created By', (data.created_by_name && data.created_by_email) ? `${data.created_by_name} (${data.created_by_email})` : (data.created_by_name || '-'))}
                    {fieldValue('Created At', data.created_at || '-')}
                </div>

                {/* Section 2: Item & Quantity */}
                {sectionLabel('Item & Quantity')}
                <div className="mb-3">
                    {fieldValue('Item', data.item_code ? `${data.item_code} - ${data.item_name}` : (data.item_name || '-'))}
                    {fieldRow('Quantity', (
                        <div className="d-flex align-items-baseline gap-2">
                            <span className={`fw-bold ${qtyColor}`} style={{ fontSize: 18 }}>{qtyDisplay}</span>
                            <small className={`${qtyColor}`}>{qtyLabel}</small>
                        </div>
                    ))}
                    {fieldValue('Unit', data.unit || '-')}
                    {fieldValue('Unit Cost', data.unit_cost ? parseFloat(data.unit_cost).toFixed(3) : '-')}
                    {fieldValue('Line Amount', data.line_amount ? parseFloat(data.line_amount).toFixed(3) : '-')}
                </div>

                {/* Section 3: Notes */}
                <div className="mb-3">
                    {sectionLabel('Notes')}
                    <div className="border rounded p-3">
                        <p className="mb-0 small">{data.notes || '-'}</p>
                    </div>
                </div>
            </div>

            {/* Footer */}
            {onClose && (
                <div className="form-footer mt-auto pt-3 border-top d-flex justify-content-end">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            )}
        </div>
    );
};

export default StockAdjustmentView;